import { Menu } from '@mantine/core';

import classes from './menu.module.css';

export const MenuOverride = Menu.extend({ classNames: classes });
